import React from 'react';
import {formatPercentScore} from 'components/manager-dashboard/Common';

export default class TableScore extends React.Component {
  render() {
    const {score} = this.props;
    const formattedScore = score != null ? formatPercentScore(score) : 'N/A';

    return (
      <span>
        {formattedScore}
        {formattedScore !== 'N/A' && <span className="saw-percent">%</span>}
      </span>
    );
  }
}
